// extracted by mini-css-extract-plugin
export var profileTabs = "profile-tabs_irPAYnTNpBa7EJGzj4jW";